import React from "react";
import "../style/parmmember_card.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import member1 from "../parm_assets/parmmembercouncil/1.png";
import member2 from "../parm_assets/parmmembercouncil/2.png";
import member3 from "../parm_assets/parmmembercouncil/3.png";
import member4 from "../parm_assets/parmmembercouncil/4.png";
import member5 from "../parm_assets/parmmembercouncil/5.png";
import member6 from "../parm_assets/parmmembercouncil/6.png";
import member7 from "../parm_assets/parmmembercouncil/7.png";
import member8 from "../parm_assets/parmmembercouncil/8.png";
import member9 from "../parm_assets/parmmembercouncil/9.png";
import member10 from "../parm_assets/parmmembercouncil/10.png";
import member11 from "../parm_assets/parmmembercouncil/11.png";
import member12 from "../parm_assets/parmmembercouncil/12.png";
import member13 from "../parm_assets/parmmembercouncil/13.png";
import infoIcon from "../parm_assets/tree_icon2_2.png";

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Import required modules
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

const members = [
  {
    name: "CA. MOHD ZAILANI",
    title: "PRESIDENT",
    image: member1,
  },
  {
    name: "CA. PUTERI NORELELA",
    title: "VICE PRESIDENT",
    image: member2,
  },
  {
    name: "CA. Mohd Asri",
    title: "HONORARY SECRETARY",
    image: member3,
  },
  {
    name: "CA. Mohd Kamil",
    title: "Honanary Treasurer",
    image: member4,
  },
  {
    name: "Prof Dr. Mohd Nazre Saleh",
    title: "COUNCIL MEMBER",
    image: member5,
  },

   {
    name: "CA. Fariza Firdaus",
    title: "COUNCIL MEMBER",
    image: member6,
  },
  {
    name: "CA. Abdul Hayat",
    title: "COUNCIL MEMBER",
    image: member7,
  },
  {
    name: "CA. Thayaalan",
    title: "COUNCIL MEMBER",
    image: member8,
  },
  {
    name: "CA. Syahrul Nizam",
    title: "COUNCIL MEMBER",
    image: member9,
  },
  {
    name: "Mohd Zufadhli",
    title: "COUNCIL MEMBER",
    image: member10,
  },
  {
    name: "CA. Lee Wei Jie",
    title: "COUNCIL MEMBER",
    image: member11,
  },

   {
    name: "CA. Noriah Mat",
    title: "AUDITOR",
    image: member12,
  },
   {
    name: "CA. Chandra Sagaran",
    title: "AUDITOR",
    image: member13,
  },
];

const CouncilMembers = () => {
  return (
    <section className="council-section">
      <div className="council-container">
        <div className="council-header">
          <p className="council-tag">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            COUNCIL MEMBER</p>
          <h2 className="council-title">PArM COUNCIL MEMBER<br />2025/2026</h2>
        </div>

        <div className="members-container" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }} >
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        spaceBetween={10}
        slidesPerView={2}
        // navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        breakpoints={{
          480: { 
      slidesPerView: 2,
      spaceBetween: 20 
    },
    568: { 
      slidesPerView: 2,
      spaceBetween: 20 
    },
    768: { 
      slidesPerView: 3,
      spaceBetween: 20 
    },
    1024: { 
      slidesPerView: 5,
      spaceBetween: 20 
    },
  }}
        className="mySwiper"
      >
        {members.map((member, index) => (
          <SwiperSlide key={index}>
            <div className="member-card">
              <img src={member.image} alt={member.name} className="member-img" />
              <div className="member-info">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>

        {/* <div className="arrow-buttons">
          <button className="arrow-btn"><FaArrowLeft /></button>
          <button className="arrow-btn active"><FaArrowRight /></button>
        </div> */}
      </div>
    </section>
  );
};

export default CouncilMembers;
